/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import Icon from '../../../_particles/icon/react/Icon';

const BurgerFallBack = ({ link }: { link: string }): React$MixedElement => {
  return (
    <a
      href={link}
      className="header__icon"
      aria-labelledby="header-icon-label--burger"
    >
      <Icon icon="burger-menu" ariaHidden={true} focusable={false} />

      <span id="header-icon-label--burger" className="header__icon-text" hidden>
        Menü
      </span>
    </a>
  );
};

export default BurgerFallBack;
